(function() {
  'use strict';

  // Bundle Selector functionality - Individual checkbox add/remove
  class BundleSelector {
    constructor() {
      this.cartItems = new Map(); // Track items in cart: variantId -> {productId, quantity, bundleType}
      this.selectedBundles = new Set(); // Track selected bundle variant IDs
      this.init();
    }

    init() {
      const bundleSelector = document.querySelector('.product-bundle-selector');
      if (!bundleSelector) return;

      // Load current cart state
      this.loadCartState();

      // Setup event listeners
      this.setupEventListeners();

      // Create arrow indicators for each card
      this.createArrowIndicators();

      // Update UI based on cart state
      this.updateUI();
      
      // Intercept main add to cart button
      this.interceptMainAddToCartButton();
    }

    async loadCartState() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Map cart items by variant ID
        cart.items.forEach(item => {
          this.cartItems.set(item.variant_id, {
            productId: item.product_id,
            quantity: item.quantity,
            key: item.key
          });
        });
      } catch (error) {
        console.error('Error loading cart:', error);
      }
    }

    createArrowIndicators() {
      // Create arrow indicator for each bundle card
      const cards = document.querySelectorAll('.bundle-option-card');
      cards.forEach(card => {
        // Check if arrow already exists
        if (card.querySelector('.bundle-card-arrow-indicator')) {
          return;
        }
        
        const arrow = document.createElement('div');
        arrow.className = 'bundle-card-arrow-indicator';
        card.appendChild(arrow);
      });
    }

    updateArrowIndicators() {
      // Show arrow only on active card, hide on others
      const cards = document.querySelectorAll('.bundle-option-card');
      cards.forEach(card => {
        const arrow = card.querySelector('.bundle-card-arrow-indicator');
        if (arrow) {
          if (card.classList.contains('active')) {
            arrow.style.opacity = '1';
          } else {
            arrow.style.opacity = '0';
          }
        }
      });
    }

    setupEventListeners() {
      // Radio (choose ONE bundle) change events
      const choices = document.querySelectorAll('.bundle-choice');
      choices.forEach(choice => {
        // Prevent scroll on focus
        choice.addEventListener('focus', (e) => {
          e.preventDefault();
        }, { passive: false });
        
        choice.addEventListener('change', (e) => {
          this.handleBundleToggle(e.target);
        });
      });

      // Variant button clicks - prevent card selection when clicking variant buttons
      const variantButtons = document.querySelectorAll('.bundle-variant-button');
      variantButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.handleVariantSelection(button);
        });
      });
      
      // Make entire card clickable
      const cards = document.querySelectorAll('.bundle-option-card');
      cards.forEach(card => {
        card.addEventListener('click', (e) => {
          // Don't trigger if clicking on variant buttons or links
          if (e.target.closest('.bundle-variant-button') || e.target.closest('a')) {
            return;
          }
          
          // Prevent default scroll behavior
          e.preventDefault();
          
          const radio = card.querySelector('.bundle-choice');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // Keychain link button (with popup)
      const keychainLink = document.querySelector('[data-keychain-link]');
      if (keychainLink) {
        keychainLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleKeychainClick(keychainLink);
        });
      }
    }

    interceptMainAddToCartButton() {
      // Find the main product add to cart button
      const mainAddToCartBtn = document.querySelector('.addtocart-js');
      if (!mainAddToCartBtn) return;
      
      // Store original click handler if exists
      const form = mainAddToCartBtn.closest('form');
      if (!form) return;
      
      // Prevent form submission completely
      const preventFormSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      };
      
      form.addEventListener('submit', preventFormSubmit, { capture: true });
      
      // Change button type to prevent form submission
      if (mainAddToCartBtn.type === 'submit') {
        mainAddToCartBtn.type = 'button';
      }
      
      // Remove existing event listeners by cloning
      const newBtn = mainAddToCartBtn.cloneNode(true);
      mainAddToCartBtn.parentNode.replaceChild(newBtn, mainAddToCartBtn);
      
      // Ensure button type is 'button' not 'submit'
      newBtn.type = 'button';
      
      // Store original button text
      const originalText = newBtn.innerHTML;
      
      // Set up button restore handler
      const restoreButton = () => {
        newBtn.disabled = false;
        newBtn.innerHTML = originalText;
      };
      
      // Listen for cart update to restore button
      const cartUpdateHandler = () => {
        restoreButton();
        // Remove listener after first call
        document.removeEventListener('cart:updated', cartUpdateHandler);
        if (typeof jQuery !== 'undefined') {
          jQuery(document).off('shopify:cart:updated', cartUpdateHandler);
        }
      };
      
      // Add our custom click handler with capture phase to intercept early
      newBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Prevent other handlers from firing
        
        // Get main product variant ID from form
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) {
          console.error('Main product variant ID not found');
          restoreButton();
          return;
        }
        const mainProductVariantId = parseInt(variantInput.value);
        if (!mainProductVariantId) {
          console.error('Invalid main product variant ID');
          restoreButton();
          return;
        }
        
        // Get quantity from form (default to 1)
        const quantityInput = form.querySelector('input[name="quantity"]');
        const mainProductQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        // Selected bundle option (radio - only one)
        const selectedChoice = document.querySelector('.bundle-choice:checked');
        
        // Disable button during processing
        newBtn.disabled = true;
        newBtn.innerHTML = '追加中...';
        
        try {
          // Build items array: main product + bundle items
          const items = [];
          
          // Add main product first
          items.push({
            id: mainProductVariantId,
            quantity: mainProductQuantity
          });
          
          // Add selected bundle item (if chosen)
          let selectedDiscountCode = null;
          if (selectedChoice) {
            const choiceVariantId = parseInt(selectedChoice.getAttribute('data-variant-id'));
            if (choiceVariantId) {
              items.push({ id: choiceVariantId, quantity: 1 });
            }
            // Get discount code from radio button
            selectedDiscountCode = selectedChoice.getAttribute('data-discount-code');
          }
          
          // Add ALL items (main product + bundle items) in a SINGLE request
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items })
          });
          
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Failed to add to cart');
          }
          
          const result = await response.json();
          
          // Update cart items tracking
          if (result.items) {
            result.items.forEach(item => {
              const variantId = item.variant_id;
              this.cartItems.set(variantId, {
                productId: item.product_id,
                quantity: item.quantity,
                key: item.key
              });
            });
          }
          
          // Update cart count and mini cart drawer
          this.updateCartCount();
          this.refreshMiniCart();
          
        // Clear bundle selection UI after successful add
        this.selectedBundles.clear();
        document.querySelectorAll('.bundle-choice').forEach(r => {
          r.checked = false;
          const card = r.closest('.bundle-option-card');
          if (card) card.classList.remove('active');
        });
        this.updateArrowIndicators();
        this.updateAddToCartButton();
          
          // Restore button immediately after successful add
          restoreButton();
          
          // DO NOT trigger jQuery 'shopify:cart:updated' - it causes:
          // 1. addToCartHandler.updateGeneralInfo() which may show modal
          // 2. addedModal.showModal() which shows popup and may cause reload
          // 3. Theme's other handlers that may interfere
          // We've already updated cart count and mini cart manually above

          // If a discount code is selected, redirect to Shopify's discount URL
          // This saves the discount code in Shopify's session (not localStorage)
          // The discount will persist even after page reload
          if (selectedDiscountCode && selectedDiscountCode.trim()) {
            const code = encodeURIComponent(selectedDiscountCode.trim());
            // Redirect to Shopify's discount URL, which will apply the code and redirect to cart
            // This is the safest method as it uses Shopify's native discount system
            window.location.href = `/discount/${code}?redirect=/cart`;
            return; // Exit early - redirect will happen
          } else {
            // No discount code selected - show success message (no redirect)
            this.showMessage('カートに追加しました', 'success');
          }
          
        } catch (error) {
          console.error('Error adding items to cart:', error);
          restoreButton();
          this.showMessage('エラーが発生しました: ' + (error.message || '不明なエラー'), 'error');
        }
        
        // Explicitly return false to prevent any default behavior
        return false;
      }, { capture: true }); // Use capture phase to intercept early
    }

    handleVariantSelection(button) {
      const card = button.closest('.bundle-option-card');
      const variantId = parseInt(button.getAttribute('data-variant-id'));
      const productId = parseInt(button.getAttribute('data-product-id'));
      const price = parseInt(button.getAttribute('data-price'));
      const imageUrl = button.getAttribute('data-image');
      const imageAlt = button.getAttribute('data-image-alt');
      const discount = parseInt(card.getAttribute('data-discount'));
      const choice = card.querySelector('.bundle-choice');

      // Get old variant ID before updating
      const oldVariantId = card.getAttribute('data-variant-id') ? parseInt(card.getAttribute('data-variant-id')) : null;

      // Update active state
      const allButtons = card.querySelectorAll('.bundle-variant-button');
      allButtons.forEach(btn => btn.classList.remove('bundle-variant-active'));
      button.classList.add('bundle-variant-active');

      // Update card data attributes
      card.setAttribute('data-product-id', productId);
      card.setAttribute('data-variant-id', variantId);

      // Update radio choice data attributes (and select it)
      if (choice) {
        choice.setAttribute('data-product-id', productId);
        choice.setAttribute('data-variant-id', variantId);
        choice.checked = true;
      }

      // Update image
      const imageEl = card.querySelector('.bundle-card-image img');
      if (imageEl && imageUrl) {
        imageEl.src = imageUrl;
        if (imageAlt) {
          imageEl.alt = imageAlt;
        }
      }

      // Update price display
      const originalPriceEl = card.querySelector('.bundle-card-price-original');
      const discountedPriceEl = card.querySelector('.bundle-card-price-discounted');
      
      if (originalPriceEl && discountedPriceEl) {
        const discounted = Math.floor(price * (100 - discount) / 100);
        originalPriceEl.textContent = this.formatPrice(price);
        discountedPriceEl.textContent = this.formatPrice(discounted);
        originalPriceEl.setAttribute('data-price', price);
        discountedPriceEl.setAttribute('data-discounted', discounted);
      }

      // Make this card active and deactivate others (radio behavior)
      document.querySelectorAll('.bundle-option-card.active').forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      // Update arrow indicators
      this.updateArrowIndicators();

      // Track selection
      this.selectedBundles.clear();
      this.selectedBundles.add(variantId);
      
      // Update description area when variant is selected
      this.updateDescriptionArea(card);
      
      this.updateAddToCartButton();
    }

    formatPrice(priceInCents) {
      const price = priceInCents / 100;
      return '¥' + price.toLocaleString('ja-JP', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    async handleBundleToggle(choice) {
      const card = choice.closest('.bundle-option-card');
      const activeVariantButton = card.querySelector('.bundle-variant-button.bundle-variant-active');
      
      // Determine selected variant/product for this card
      let variantId;
      let productId;

      if (activeVariantButton) {
        variantId = parseInt(activeVariantButton.getAttribute('data-variant-id'));
        productId = parseInt(activeVariantButton.getAttribute('data-product-id'));
      } else {
        variantId = parseInt(choice.getAttribute('data-variant-id'));
        productId = parseInt(choice.getAttribute('data-product-id'));
      }
        
      if (!variantId || !productId) {
        console.error('Missing variant or product ID');
        return;
      }

      // Radio behavior: deactivate all cards, then activate selected one
      document.querySelectorAll('.bundle-option-card.active').forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      // Update arrow indicators
      this.updateArrowIndicators();

      this.selectedBundles.clear();
      this.selectedBundles.add(variantId);

      // Update description area
      this.updateDescriptionArea(card);

      this.updateAddToCartButton();
    }

    updateDescriptionArea(card) {
      const descriptionArea = document.getElementById('bundleDescriptionArea');
      if (!descriptionArea) return;
      
      const content = descriptionArea.querySelector('.bundle-description-content');
      if (!content) return;
      
      if (!card) {
        // Hide description if no card selected
        descriptionArea.classList.add('hidden');
        return;
      }
      
      const title = card.getAttribute('data-description-title') || '';
      const line1 = card.getAttribute('data-description-line1') || '';
      const line2 = card.getAttribute('data-description-line2') || '';
      const line3 = card.getAttribute('data-description-line3') || '';
      
      // Fade out current content
      content.classList.add('fade-out');
      
      // Update content after fade out
      setTimeout(() => {
        let html = '<div class="bundle-description-title">── セット内容について ──</div><div class="bundle-description-text">';
        
        if (title) {
          html += `<p class="bundle-description-main">${title}</p>`;
        }
        if (line1) {
          html += `<p class="bundle-description-main">${line1}</p>`;
        }
        if (line2) {
          html += `<p class="bundle-description-main">${line2}</p>`;
        }
        if (line3) {
          html += `<p class="bundle-description-small">${line3}</p>`;
        }
        
        html += '</div>';
        content.innerHTML = html;
        
        // Remove fade-out and add fade-in
        content.classList.remove('fade-out');
        content.classList.add('fade-in');
        
        // Show description area
        descriptionArea.classList.remove('hidden');
        
        // Add highlight effect when description appears
        descriptionArea.classList.add('highlighted');
        setTimeout(() => {
          descriptionArea.classList.remove('highlighted');
        }, 600);
        
        // Remove fade-in class after animation completes
        setTimeout(() => {
          content.classList.remove('fade-in');
        }, 200);
      }, 100);
    }

    async handleKeychainClick(link) {
      // Show popup first
      const shouldNavigate = await this.showKeychainPopup();
      
      if (shouldNavigate) {
        // Navigate to keychain product page
        window.location.href = link.href;
      }
    }

    async handleAddToCart(suppressMessage = false) {
      if (this.selectedBundles.size === 0) {
        return;
      }

      try {
        // Legacy method (kept for compatibility): add the selected radio bundle item only
        const selectedChoice = document.querySelector('.bundle-choice:checked');
        if (!selectedChoice) return;

        const variantId = parseInt(selectedChoice.getAttribute('data-variant-id'));
        if (!variantId) return;

        const items = [{ id: variantId, quantity: 1 }];

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add to cart');
        }

        const result = await response.json();
        
        // Update cart items tracking
        if (result.items) {
          result.items.forEach(item => {
            const variantId = item.variant_id;
            this.cartItems.set(variantId, {
              productId: item.product_id,
              quantity: item.quantity,
              key: item.key
            });
          });
        }
        
        // Wait a moment for cart to update
        await new Promise(resolve => setTimeout(resolve, 300));
        
        this.updateCartCount();
        
        // Update mini cart drawer with all cart items
        this.refreshMiniCart();
        
        // Show success message only if not suppressed (when called from main button)
        if (!suppressMessage) {
          let message = `商品をカートに追加しました`;
          this.showMessage(message, 'success');
        }
        
        // Clear selections
        this.selectedBundles.clear();
        document.querySelectorAll('.bundle-choice').forEach(r => {
          r.checked = false;
          const card = r.closest('.bundle-option-card');
          if (card) card.classList.remove('active');
        });

        // Update arrow indicators
        this.updateArrowIndicators();

        // Reset description area
        this.updateDescriptionArea(null);

        this.updateAddToCartButton();
      } catch (error) {
        console.error('Error in handleAddToCart:', error);
        if (!suppressMessage) {
          this.showMessage('エラーが発生しました: ' + (error.message || '不明なエラー'), 'error');
        }
        throw error; // Re-throw so caller can handle it
      }
    }

    async addToCart(variantId, productId, quantity) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add to cart');
        }

        const item = await response.json();
        this.cartItems.set(variantId, {
          productId: productId,
          quantity: item.quantity,
          key: item.key
        });

        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.updateCartCount();

        return item;
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showMessage('エラーが発生しました: ' + error.message, 'error');
        throw error;
      }
    }

    async removeFromCart(variantId) {
      try {
        // Get cart to find the item key
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const cartItem = cart.items.find(item => item.variant_id === variantId);
        if (!cartItem) {
          console.warn('Item not found in cart');
          return;
        }

        // Update quantity to 0 to remove
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {
              [cartItem.key]: 0
            }
          })
        });

        if (!response.ok) {
          throw new Error('Failed to remove from cart');
        }

        this.cartItems.delete(variantId);

        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.updateCartCount();
      } catch (error) {
        console.error('Error removing from cart:', error);
        this.showMessage('エラーが発生しました: ' + error.message, 'error');
        throw error;
      }
    }

    updateUI() {
      // We intentionally do not auto-select bundle radios based on cart contents.
      this.updateAddToCartButton();
    }

    updateAddToCartButton() {
      // Button removed - no longer needed
      // This method is kept for compatibility but does nothing
      // The main Add to Cart button now handles bundle items automatically
    }

    // Discount codes are now handled via Shopify's native discount system
    async applyBundleDiscountCodes() {
      return false;
    }

    updateCartCount() {
      // Update cart count by fetching cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Update cart badge count
          const badgeElements = document.querySelectorAll('.sp-badge-cart');
          badgeElements.forEach(badge => {
            badge.textContent = cart.item_count;
            if (cart.item_count === 0) {
              badge.classList.add('hide');
            } else {
              badge.classList.remove('hide');
            }
          });
          
          // Update cart total price if element exists
          const totalPriceElements = document.querySelectorAll('.sp-cart-total-price');
          if (totalPriceElements.length > 0 && typeof getItemFormatedPrice === 'function') {
            const priceStr = getItemFormatedPrice(cart.total_price);
            totalPriceElements.forEach(el => {
              el.innerHTML = priceStr;
            });
          }
          
          // Call theme's update function if it exists
          if (typeof addToCartHandler !== 'undefined' && typeof addToCartHandler.updateGeneralInfo === 'function') {
            addToCartHandler.updateGeneralInfo(cart);
          }
          
          // Trigger custom event for other scripts
          document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: { cart } }));
        })
        .catch(error => {
          console.error('Error updating cart count:', error);
        });
    }

    refreshMiniCart() {
      // Check if jQuery and addToCartHandler are available
      if (typeof jQuery === 'undefined' || typeof addToCartHandler === 'undefined') {
        // Fallback: just update cart count
        this.updateCartCount();
        return;
      }
      
      const $ = jQuery;
      
      // Get bundle discount information
      const bundleDiscounts = this.getBundleDiscounts();
      
      // Fetch full cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Clear existing items in mini cart list
          const $cartList = $('header').find('.sp-cart-list');
          if ($cartList.length) {
            $cartList.empty();
          }
          
          // Add each cart item to mini cart using theme's handler
          if (typeof addToCartHandler.addItem === 'function') {
            cart.items.forEach((item) => {
              addToCartHandler.addItem(item);
              
              // Apply discount price display if item is part of bundle
              this.applyDiscountToMiniCartItem(item, bundleDiscounts);
            });
          }
          
          // Calculate discounted subtotal
          const discountedSubtotal = this.calculateDiscountedSubtotal(cart.items, bundleDiscounts);
          
          // Update cart general info (badge, total price, etc.)
          if (typeof addToCartHandler.updateGeneralInfo === 'function') {
            addToCartHandler.updateGeneralInfo(cart);
          }
          
          // Update subtotal with discounted price if applicable
          this.updateMiniCartSubtotal(discountedSubtotal, cart.total_price);
          
          // Show/hide empty cart message
          const $emptyCart = $('.sp-cart-empty');
          const $cartBox = $('.sp-cart-box');
          if (cart.item_count === 0) {
            if ($emptyCart.length) $emptyCart.removeClass('hide');
            if ($cartBox.length) $cartBox.addClass('hide');
          } else {
            if ($emptyCart.length) $emptyCart.addClass('hide');
            if ($cartBox.length) $cartBox.removeClass('hide');
          }
          
          // Trigger currency refresh if available
          if (typeof $('body').trigger === 'function') {
            $('body').trigger('refreshCurrency');
          }
        })
        .catch(error => {
          console.error('Error refreshing mini cart:', error);
          // Fallback: just update cart count
          this.updateCartCount();
        });
    }

    // Discount info storage is handled via Shopify's native discount system
    getBundleDiscounts() {
      return {};
    }

      // Price/discount display is handled by Shopify's native system
    applyDiscountToMiniCartItem() {
      return;
    }

    calculateDiscountedSubtotal(items) {
      // Return original subtotal (no manual discount math)
      return items.reduce((sum, item) => sum + item.line_price, 0);
    }

    updateMiniCartSubtotal() {
      // No-op (Shopify handles discount display)
    }

    formatPrice(priceInCents) {
      const price = priceInCents / 100;
      return '¥' + price.toLocaleString('ja-JP', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    showKeychainPopup() {
      return new Promise((resolve) => {
        // Calculate savings from bundle discounts
        const bundleCards = document.querySelectorAll('.bundle-option-card');
        let minSavings = Infinity;
        let bestBundle = null;
        let savingsAmount = 0;

        bundleCards.forEach(card => {
          const discount = parseInt(card.getAttribute('data-discount')) || 0;
          if (discount > 0 && discount < minSavings) {
            minSavings = discount;
            bestBundle = card.querySelector('.bundle-card-title')?.textContent || '';
          }
        });

        // Get current product price
        const priceElement = document.querySelector('.sp-price .new-price, .sp-price .old-price');
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^\d,]/g, '').replace(/,/g, '');
          const productPrice = parseInt(priceText) || 0;
          savingsAmount = Math.floor(productPrice * minSavings / 100);
        }

        // Create popup
        const popup = document.createElement('div');
        popup.className = 'bundle-keychain-popup';
        popup.innerHTML = `
          <div class="bundle-keychain-popup-overlay"></div>
          <div class="bundle-keychain-popup-content">
            <button class="bundle-keychain-popup-close" aria-label="Close">×</button>
            <h3 class="bundle-keychain-popup-title">セット割がお得です！</h3>
            <p class="bundle-keychain-popup-message">
              ＋${savingsAmount.toLocaleString()}円でセット割がお得です
            </p>
            <p class="bundle-keychain-popup-submessage">
              ${bestBundle}と一緒に購入すると${minSavings}%OFF
            </p>
            <div class="bundle-keychain-popup-actions">
              <button class="btn-bundle-keychain-popup-close">閉じる</button>
              <button class="btn-bundle-keychain-popup-bundle">セット割を確認</button>
            </div>
          </div>
        `;

        document.body.appendChild(popup);
        document.body.style.overflow = 'hidden';

        // Close handlers
        const closeBtn = popup.querySelector('.bundle-keychain-popup-close');
        const overlay = popup.querySelector('.bundle-keychain-popup-overlay');
        const closeActionBtn = popup.querySelector('.btn-bundle-keychain-popup-close');
        const bundleBtn = popup.querySelector('.btn-bundle-keychain-popup-bundle');

        const closePopup = (navigate = false) => {
          popup.remove();
          document.body.style.overflow = '';
          resolve(navigate);
        };

        closeBtn.addEventListener('click', () => closePopup(false));
        closeActionBtn.addEventListener('click', () => closePopup(false));
        overlay.addEventListener('click', () => closePopup(false));
        bundleBtn.addEventListener('click', () => {
          closePopup(false);
          // Scroll to bundle options
          const bundleOptions = document.querySelector('.bundle-options-container');
          if (bundleOptions) {
            bundleOptions.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });

        // Close on Escape
        const escapeHandler = (e) => {
          if (e.key === 'Escape') {
            closePopup(false);
            document.removeEventListener('keydown', escapeHandler);
          }
        };
        document.addEventListener('keydown', escapeHandler);
      });
    }

    showMessage(message, type) {
      // Create or update message element
      let messageEl = document.querySelector('.bundle-message');
      if (!messageEl) {
        messageEl = document.createElement('div');
        messageEl.className = 'bundle-message';
        const bundleSelector = document.querySelector('.product-bundle-selector');
        if (bundleSelector) {
          bundleSelector.insertBefore(messageEl, bundleSelector.firstChild);
        }
      }

      messageEl.textContent = message;
      messageEl.className = `bundle-message bundle-message-${type}`;
      messageEl.style.display = 'block';

      // Hide after 3 seconds
      setTimeout(() => {
        messageEl.style.display = 'none';
      }, 3000);
    }

    // Discounts are handled by Shopify's native system
    applyDiscountsToExistingCartItems() {
      return;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      const bundleSelector = new BundleSelector();
      // Discounts are managed by Shopify's native system
    });
  } else {
    const bundleSelector = new BundleSelector();
      // Discounts are managed by Shopify's native system
  }

  // Re-initialize on dynamic content updates
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      const bundleSelector = new BundleSelector();
      // Discounts are managed by Shopify's native system
      // Arrow indicators will be created in init()
    }, 100);
  });

  // Apply discounts when cart drawer is opened
  if (typeof jQuery !== 'undefined') {
    const $ = jQuery;
    $(document).on('click', '.sp-dropdown-toggle', function() {
      const $dropdown = $(this).closest('.sp-dropdown-obj');
      if ($dropdown.find('.sp-cart').length > 0) {
        // Cart drawer is being opened
        setTimeout(() => {
          const bundleSelector = new BundleSelector();
          // Discounts are managed by Shopify's native system
        }, 300);
      }
    });
  }

})();
